var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpRequestUrl } from '@bolteu/http-client';
import { HttpInterceptorVirtualPaths } from '@bolteu/http-interceptor-virtual-paths-bolt-server';
import { ShardingStrategy } from '@bolteu/http-request-bolt-server';
var HttpInterceptorUrlSharding = /** @class */ (function () {
    function HttpInterceptorUrlSharding(config) {
        this.config = config;
    }
    HttpInterceptorUrlSharding.prototype.intercept = function (req, next) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var shardKey, newUrl;
            return __generator(this, function (_b) {
                if (((_a = req.meta) === null || _a === void 0 ? void 0 : _a.sharding.enabled) && req.meta.sharding.strategy === ShardingStrategy.URL) {
                    if (HttpInterceptorVirtualPaths.isVirtualPathsEnabled(req)) {
                        throw new Error('Cannot use virtual paths with URL-based sharding!');
                    }
                    shardKey = this.config.getShardKey();
                    if (req.opts && typeof req.opts === 'object' && req.opts.shardKey !== undefined) {
                        if (typeof req.opts.shardKey === 'string') {
                            shardKey = req.opts.shardKey;
                        }
                        else {
                            throw new Error('Url sharding scheme does not support non-string values');
                        }
                    }
                    if (shardKey !== null) {
                        newUrl = new URL(req.url.toString());
                        newUrl.pathname = HttpRequestUrl.buildRequestUrl(req.baseUrl, "/" + shardKey + "-" + req.path.substring(1)).pathname;
                        req.setUrl(newUrl);
                    }
                }
                return [2 /*return*/, next(req)];
            });
        });
    };
    return HttpInterceptorUrlSharding;
}());
export { HttpInterceptorUrlSharding };
